import { useTranslation } from "react-i18next";

// من أقرّ باستلام راتبه، من لم يُقرّ بعد، ومن أبلغ بعدم الاستلام مع السبب (للإدارة).
export const PayrollReceiptList = ({ receipts }) => {
  const { t } = useTranslation();
  if (!receipts?.length) return null;
  const tone = (r) =>
    r.not_received ? "text-destructive" : r.acknowledged ? "text-success" : "text-muted-foreground";
  const label = (r) =>
    t(r.not_received ? "payrollCycle.notReceived" : r.acknowledged ? "payrollCycle.received" : "payrollCycle.pending");
  return (
    <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {receipts.map((r) => (
        <div key={r.user_id} className="rounded-2xl p-2 shadow-neu-in" data-testid={`payroll-receipt-${r.user_id}`}>
          <div className="flex items-center justify-between gap-2">
            <span className="min-w-0 flex-1 truncate text-xs font-bold">{r.name}</span>
            <span className={`shrink-0 text-[11px] font-black ${tone(r)}`}>{label(r)}</span>
          </div>
          {r.not_received && r.reason && (
            <p className="mt-1 truncate text-[11px] text-destructive" title={r.reason}
              data-testid={`receipt-reason-${r.user_id}`}>
              {r.reason}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};
